<script>
import Layout from '@layouts/main'
import ProjectSummary from '@/src/components/HMDA/TabItems/ProjectSummary.vue'
import FileManager from '@/src/components/HMDA/TabItems/FileManager.vue'
import ProjectLog from '@/src/components/HMDA/TabItems/ProjectLog.vue'
import { hmdaACL } from '@/src/utils/accesslevels'
import { hmdaGetters, toasterMethods } from '@state/helpers'
import HmdaHeader from '@/src/components/HMDA/HmdaHeader.vue'

export default {
  components: { Layout, ProjectSummary, FileManager, ProjectLog, HmdaHeader },
  data() {
    return {
      projectDetails: {},
      showSpinner: false,
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        {
          text: 'Projects',
          to: { name: 'hmda-view-projects' },
        },
        { text: 'Project Summary', active: true },
      ],
      canAccessProjectSummary: false,
      canAccessProjectFiles: false,
      canAccessProjectActivity: false,
    }
  },

  computed: {
    ...hmdaGetters,
    projectId() {
      return this.$route.params.id || '0'
    },
  },

  mounted() {
    hmdaACL.initializeAccessControls()
    this.canAccessProjectSummary = hmdaACL.canViewHmdaProjectSummary()
    this.canAccessProjectFiles = hmdaACL.canViewHmdaProjectFiles()
    this.canAccessProjectActivity = hmdaACL.canViewHmdaProjectActivity()
  },

  created() {},

  methods: {
    ...toasterMethods,
    updateActivityLogs() {
      this.$refs.actlogs.getActivityLogs()

    },
    reloadActivityLogs() {
      this.$refs.actlogs.getActivityLogs()
    },
    reloadProjectSummary() {
      this.$refs.proSummary.reloadAllData()
    },
  },
}
</script>

<style scoped>
.myavatar {
  background-color: #86d4e0;
}
.myavatar:hover {
  background-color: #47bfd1;
}
.myavatar svg {
  color: white;
}
::v-deep .card-header.side-nav-class {
  /* background: red !important; */
  padding: 0px !important;
}
::v-deep .side-nav-active-class {
  background-color: transparent !important;
}
.side-nav-active-class .myavatar {
  background-color: #4b868f;
}
</style>
<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />
    <HmdaHeader :crumbs="breadcrumbs" />
    <div class="body--wrapper mt-1 bg-white container">
      <div class="float-right">
        <b-dropdown
          right
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <!-- <template v-slot:button-content>
            <BaseIcon name="ellipsis-v" />
          </template> -->
          <!-- <b-dropdown-item @click="gotoRunRules">Run rules</b-dropdown-item> -->
        </b-dropdown>
      </div>

      <BaseTitleMenu
        :heade-title="projectSummary.projectName"
        class="text-capitalize border-bottom pb-3"
      />

      <b-tabs
        pills
        card
        vertical
        nav-wrapper-class="w-10"
        style="min-height: 100vh;"
        nav-class="side-nav-class"
        active-nav-item-class="side-nav-active-class"
        active-tab-class=""
      >
        <b-tab v-if="canAccessProjectSummary" @click="reloadProjectSummary">
          <template v-slot:title>
            <b-avatar size="lg" class="myavatar">
              <BaseIcon id="tabSummary" name="chart-area" size="lg" />
            </b-avatar>
            <b-tooltip target="tabSummary" triggers="hover" placement="right">
              Project Summary
            </b-tooltip>
          </template>
          <ProjectSummary ref="proSummary" :project-id="projectId" @updateActivityLogs="updateActivityLogs" />
        </b-tab>
        <b-tab v-if="canAccessProjectFiles" title="Files">
          <template v-slot:title>
            <b-avatar size="lg" class="myavatar">
              <BaseIcon id="tabFiles" name="folder-open" size="lg" />
            </b-avatar>
            <b-tooltip target="tabFiles" triggers="hover" placement="right">
              Files
            </b-tooltip>
          </template>
          <FileManager />
        </b-tab>
        <b-tab v-if="canAccessProjectActivity" title="History" @click="reloadActivityLogs">
          <template v-slot:title>
            <b-avatar size="lg" class="myavatar">
              <BaseIcon id="tabLogs" name="list-ul" size="lg" />
            </b-avatar>
            <b-tooltip target="tabLogs" triggers="hover" placement="right">
              Activity Logs
            </b-tooltip>
          </template>
          <ProjectLog ref="actlogs" :project-id="projectId" />
        </b-tab>
      </b-tabs>
    </div>
  </Layout>
</template>
